export enum EventStatusOperation {
  CREATION = 'CREATION',
  MINOR_EDITION = 'MINOR_EDITION',
  CANCELLED_DELETED = 'CANCELLED_DELETED',
  MAJOR_EDITION = 'MAJOR_EDITION',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}
